import { LeadCallOutcome } from '../../../../Model/Lead';

import texts from './texts';

export const getCallOutcomeValidationError = ({
  callOutcomeNote,
  leadCallOutcome,
  reason,
  isMaxAttemptsReached,
  isAutoLostScenario,
  isAutoLostConfirmed,
  attemptType,
  followUpDate,
  isIntentFlagRequired,
  intentFlag,
}) => {
  // A missing outcome would be saved as a null history value and break the history view.
  if (!leadCallOutcome) {
    return texts.leadOutcomeRequired;
  }

  if (leadCallOutcome === LeadCallOutcome.LOST && !reason) {
    return texts.lostReasonRequired;
  }

  if (leadCallOutcome === LeadCallOutcome.FOLLOW_UP && !reason) {
    return texts.followUpReasonRequired;
  }

  if (isIntentFlagRequired && !intentFlag) {
    return texts.intentFlagRequired;
  }

  if (leadCallOutcome === LeadCallOutcome.NOT_ANSWERED && isMaxAttemptsReached) {
    return texts.maxAttemptsReached;
  }

  if (leadCallOutcome === LeadCallOutcome.NOT_ANSWERED && !attemptType) {
    return texts.attemptTypeRequired;
  }

  if (isAutoLostScenario && !isAutoLostConfirmed) {
    return texts.autoLostConfirmRequired;
  }

  if (leadCallOutcome === LeadCallOutcome.FOLLOW_UP && !followUpDate) {
    return texts.followUpDateRequired;
  }

  if ((leadCallOutcome === LeadCallOutcome.WON
    || leadCallOutcome === LeadCallOutcome.FOLLOW_UP)
    && !callOutcomeNote.trim()) {
    return texts.outcomeNoteRequired;
  }

  return null;
};
